import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
import createCompressor from "redux-persist-transform-compress";
import { encryptTransform } from "redux-persist-transform-encrypt";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../redux/reducers";
import rootSaga from "../redux/sagas";

function configureAppStore(initialState = {}) {
	const isProduction = Boolean(process.env.NODE_ENV === "production");

	const sagaMiddleware = createSagaMiddleware();

	const logger = createLogger({
		collapsed: true,
		level: "warn",
		logErrors: true,
	});

	const middleware = isProduction ? [sagaMiddleware] : [sagaMiddleware, logger];

	const compressor = createCompressor();
	const encryptor = encryptTransform({
		secretKey: "$#TO$`*G#PK$F*#PKSÇLDFKS$OK#PRK#FP*#KFP*#FKVMV|!#$%&/((/&%$#!",
	});

	const persistConfig = {
		key: "root",
		version: 1,
		storage,
		transforms: [encryptor, compressor],
	};

	const store = configureStore({
		reducer: persistReducer(persistConfig, rootReducer),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false,
				immutableCheck: false,
			}).concat(middleware),
		devTools: !isProduction,
		preloadedState: initialState,
	});

	store.sagaTask = sagaMiddleware.run(rootSaga);
	let persistor = persistStore(store);

	if (process.env.NODE_ENV === "development" && module.hot) {
		module.hot.accept("../redux/reducers", () => {
			const newReducer = require("../redux/reducers").default;
			store.replaceReducer(newReducer);
		});
	}

	return { store, persistor };
}

export default configureAppStore;
